<template>
	<transition name="dim-fade">
		<div v-if="showPopup" class="background-dim">
			<transition name="popup-fade">
				<div name="fade-action" class="popup border-l container">
					<h1 class="title">{{ popup.title }}</h1>
					<h3 class="description">{{ popup.description }}</h3>
					<secondary-button
						class="full-width mt-16"
						@click="hidePopupError"
						>Dismiss</secondary-button
					>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SecondaryButton from "../ui/SecondaryButton";
export default {
	components: {
		SecondaryButton,
	},
	computed: {
		...mapGetters(["showPopup", "popup"]),
	},
	methods: {
		...mapActions(["hidePopupError"]),
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/main.scss";
.background-dim {
	position: absolute;
	z-index: 1000;
	width: 100%;
	height: 100%;
	background-color: #0004;
	display: flex;
	align-items: center;
	justify-content: center;
}
.popup {
	padding: 32px 24px;
	min-width: 300px;
	.description {
		color: lighten($blue-lightest, 10%);
	}
}

.dim-fade-enter-from,
.dim-fade-leave-to {
	opacity: 0;
	.popup {
		transform: translateY(20px);
	}
}
.dim-fade-enter-active,
.dim-fade-leave-active {
	$duration: 0.3s;
	transition: all $duration ease;
	.popup {
		transition: all $duration ease;
	}
}
</style>
